import { render, staticRenderFns } from "./whiteNameList.vue?vue&type=template&id=66004382&scoped=true&"
import script from "./whiteNameList.vue?vue&type=script&lang=js&"
export * from "./whiteNameList.vue?vue&type=script&lang=js&"
import style0 from "./whiteNameList.vue?vue&type=style&index=0&id=66004382&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66004382",
  null
  
)

export default component.exports